import { useState, useEffect } from "react";
import { Box, Typography, TextField, Divider } from "@mui/material";
import { UseOrdersReport } from "../UseOrdersReport";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import CategoryGrid from "./CategoryGrid";
import BrandGrid from "./BrandGrid";
import GroupGrid from "./GroupGrid";
import ProductGrid from "./ProductGrid";
import { useLocation } from "react-router-dom";
import { toMoney } from "../../../util/Utils";
import useBreakpoints from "../../../hooks/useBreakpoints";
import PaymentGrid from "./PaymentGrid";
import BankGrid from "./BankGrid";
import InstallmentGrid from "./InstallmentGrid";
import DeliveryGrid from "./DeliveryGrid";

export default function OrderReportDetails(props) {
  const { GetGeneralDetails } = UseOrdersReport();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [detailRes, setDetailRes] = useState();
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (location.state) {
      GetGeneralDetails(
        location.state.startDate,
        location.state.endDate,
        (callback) => {
          setDetailRes(callback);
        },
      );
    }
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        // backButtonDef: {
        //   state: {
        //     yearReport: yearReport,
        //     monthReport: monthReport,
        //     myPc: myPc,
        //     reportState: reportState,
        //   },
        //   replace: true,
        // },
        backURL: "/ordersreport",
        title: "گزارشات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/ordersreport" },
          { name: "جزئیات گزارش", url: "/ordersreport/OrderReportDetails" },
        ],
      }}
    >
      <Box sx={{ mb: 5 }}>
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          گزارش {location.state && location.state.name} :
          {location.state && location.state.ReportName}
        </Typography>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="تعداد سفارش"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={detailRes ? toMoney(detailRes.orderCount) : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="مجموع سفارشات"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={detailRes ? detailRes.totalCost : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="هزینه ارسال"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={detailRes ? detailRes.deliverycost : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="کد تخفیف"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={detailRes ? detailRes.totalDiscountCode : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="تخفیف اعتباری"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={detailRes ? detailRes.totalDiscountCredit : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="تعداد هدیه"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={detailRes ? toMoney(detailRes.giftcount) : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="تخفیف مستقیم"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={detailRes ? detailRes.totalDiscount : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="درصد تخفیف مستقیم"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={detailRes ? detailRes.totalDiscountPercent : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="مجموع پرداخت شده"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={detailRes ? detailRes.totalPaycost : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="میانگین هر خرید"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={detailRes ? detailRes.avragePaycost : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="حداقل سفارش"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={detailRes ? detailRes.minPaycost : ""}
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 6" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="حداکثر سفارش"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={detailRes ? detailRes.maxPaycost : ""}
              variant="filled"
            />
          </Box>
        </Box>
      </Box>
      <PaymentGrid
        startDate={location.state && location.state.startDate}
        endDate={location.state && location.state.endDate}
      ></PaymentGrid>
      <Divider sx={{ py: 5 }}></Divider>
      <BankGrid
        startDate={location.state && location.state.startDate}
        endDate={location.state && location.state.endDate}
      ></BankGrid>
      <Divider sx={{ py: 5 }}></Divider>
      <InstallmentGrid
        startDate={location.state && location.state.startDate}
        endDate={location.state && location.state.endDate}
      ></InstallmentGrid>
      <Divider sx={{ py: 5 }}></Divider>
      <DeliveryGrid
        startDate={location.state && location.state.startDate}
        endDate={location.state && location.state.endDate}
      ></DeliveryGrid>
      <Divider sx={{ py: 5 }}></Divider>
      <CategoryGrid
        startDate={location.state && location.state.startDate}
        endDate={location.state && location.state.endDate}
      ></CategoryGrid>
      <Divider sx={{ py: 5 }}></Divider>
      <BrandGrid
        startDate={location.state && location.state.startDate}
        endDate={location.state && location.state.endDate}
      ></BrandGrid>
      <Divider sx={{ py: 5 }}></Divider>
      <GroupGrid
        startDate={location.state && location.state.startDate}
        endDate={location.state && location.state.endDate}
      ></GroupGrid>
      <Divider sx={{ py: 5 }}></Divider>
      <ProductGrid
        startDate={location.state && location.state.startDate}
        endDate={location.state && location.state.endDate}
      ></ProductGrid>
      <Divider sx={{ py: 5 }}></Divider>
    </Detail>
  );
}
